// @flow

import React from 'react';

import Button from 'app/common/components/Button';
import ButtonGroup from 'app/common/components/ButtonGroup';
import Modal from 'app/common/components/Modal';
import InfoBlock, {
  InfoBlockDescription,
  InfoBlockStaticImage,
  InfoBlockTitle,
} from 'app/common/components/InfoBlock';

type DowngradedModalProps = {
  ownerName: string,
  planName: string,
  profileId: number,
  trackingKey: string,
  onClose: (trackingKey: string, profileId: number) => void,
};

const DowngradedModal = (props: DowngradedModalProps) => {
  const onClose = () => props.onClose(props.trackingKey, props.profileId);
  return (
    <Modal
      closeOnEsc={false}
      closeOnOutsideClick={false}
      contentClassName=""
      isOpened={true}
      kind="narrow"
      onClose={onClose}
    >
      <InfoBlock kind="bare centered">
        <InfoBlockStaticImage
          alt="Your account has been downgraded"
          src="images/zaplings/folder-wave.svg"
        />
        <InfoBlockTitle>Your Teams Plan Was Paused</InfoBlockTitle>
        <InfoBlockDescription>
          Your team owner, {props.ownerName}, paused your team’s plan. Don’t
          worry: you can still use Zapier on your {props.planName} plan—with a
          few changes.
        </InfoBlockDescription>
        <ButtonGroup kind="horizontal justify-center">
          <Button
            href="/help/account/teams/cancel-your-zapier-for-teams-plan"
            kind="secondary large min-width"
            onClick={onClose}
          >
            Got it!
          </Button>
          <Button
            href="/help/account/teams/cancel-your-zapier-for-teams-plan"
            kind="team large"
            tag="Link"
          >
            See What Changed
          </Button>
        </ButtonGroup>
      </InfoBlock>
    </Modal>
  );
};

export default DowngradedModal;
